document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const checkoutBtn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutBtn) return;

    // Find the container to scope the checkbox search
    let container = checkoutBtn.closest('cart-drawer') || checkoutBtn.closest('#main-cart-footer') || document;
    const checkbox = container.querySelector('.cart__terms-checkbox');
    
    if (checkbox && !checkbox.checked) {
      e.preventDefault();
      const alertText = (window.cartStrings && window.cartStrings.cartTermsConfirmation) || 'You must agree to the terms and conditions of sales to check out.';
      alert(alertText);
    }
  });
});
